module.exports = __webpack_public_path__ + "img/BEBADO.e9f23616.jpg";